const $ = jQuery.noConflict()

$.fn.extend({
  calculators: function() {
    self.init(this.selector)
  }
})


jQuery('<div class="quantity-nav"><div class="quantity-button quantity-up"><i class="fa fa-angle-right" aria-hidden="true"></i></div><div class="quantity-button quantity-down"><i class="fa fa-angle-left" aria-hidden="true"></i></div></div>').insertAfter('.quantity input');
    jQuery('.quantity').each(function() {
      var spinner = jQuery(this),
        input = spinner.find('input[type="number"]'),
        btnUp = spinner.find('.quantity-up'),
        btnDown = spinner.find('.quantity-down'),
        min = input.attr('min'),
        max = input.attr('max');

      btnUp.on("click", function() {
        var oldValue = parseFloat(input.val());
        if (oldValue >= max) {
          var newVal = oldValue;
        } else {
          if(spinner.hasClass( "mortgage-calculator-price" )){
            var newVal = oldValue + 1000;
          }else if(spinner.hasClass( "mortgage-calculator-deposit" )){
            var newVal = oldValue + 500;
          }else{
            var newVal = oldValue + 1;
          }

        }
        spinner.find("input").val(newVal);
        spinner.find("input").trigger("change");
      });

      btnDown.on("click", function() {
        var oldValue = parseFloat(input.val());
        if (oldValue <= min) {
          var newVal = oldValue;
        } else {
          if(spinner.hasClass( "mortgage-calculator-price" )){
            var newVal = oldValue - 1000;
          }else if(spinner.hasClass( "mortgage-calculator-deposit" )){
            var newVal = oldValue - 500;
          }else{
            var newVal = oldValue - 1;
          }
          
        }
        spinner.find("input").val(newVal);
        spinner.find("input").trigger("change");
      });

    });